import { useEffect, useState } from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import api from "http";
import { toast } from "react-toastify";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import NumberConversion from "Utils/NumberConversion";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import UnKnownCardIcon from "SVGS/UnKnownCardIcon";
import CardImage from "./CardImage";
import { PAYMENT_SUCCESSFUL } from "Common/ToastConstants";
export const cardSVGs = {
  visa: <CardImage path="/img/card_svgs/visa.svg" alt="Visa" />,
  mastercard: (
    <CardImage path="/img/card_svgs/mastercard.svg" alt="Mastercard" />
  ),
  amex: <CardImage path="/img/card_svgs/amex.svg" alt="Amex" />,
  discover: <CardImage path="/img/card_svgs/discover.svg" alt="Discover" />,
  diners: <CardImage path="/img/card_svgs/diners.svg" alt="Diners" />,
  jcb: <CardImage path="/img/card_svgs/jcb.svg" alt="JCB" />,
  unionpay: <CardImage path="/img/card_svgs/unionpay.svg" alt="UnionPay" />,
  maestro: <CardImage path="/img/card_svgs/maestro.svg" alt="Maestro" />,
  elo: <CardImage path="/img/card_svgs/elo.svg" alt="Elo" />,
  hipercard: <CardImage path="/img/card_svgs/hipercard.svg" alt="Hipercard" />,
  mir: <CardImage path="/img/card_svgs/mir.svg" alt="Mir" />,
  rupay: <CardImage path="/img/card_svgs/rupay.svg" alt="RuPay" />,
  interac: <CardImage path="/img/card_svgs/interac.svg" alt="Interac" />,
  cirrus: <CardImage path="/img/card_svgs/cirrus.svg" alt="Cirrus" />,
  pulse: <CardImage path="/img/card_svgs/pulse.svg" alt="Pulse" />,
  star: <CardImage path="/img/card_svgs/star.svg" alt="Star" />,
  nyce: <CardImage path="/img/card_svgs/nyce.svg" alt="NYCE" />,
  accel: <CardImage path="/img/card_svgs/accel.svg" alt="Accel" />,
  plus: <CardImage path="/img/card_svgs/plus.svg" alt="Plus" />,
  unknown: <UnKnownCardIcon />,
};
const CheckoutForm = ({
  Model,
  paymentModel,
  stripeSettingId,
  onClose,
  patientInfo,
  patientDetail,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [state, setState] = useState({
    isLoading: false,
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [creditCards, setCreditCards] = useState([]);
  const [activeCard, setActiveCard] = useState("cardNumber");

  const handleSubmit = async (e) => {
    if (!stripe || !elements) {
      return;
    }
    setIsProcessing(true);
    let paymentMethodId;

    try {
      setState((prev) => ({ ...prev, isLoading: true }));

      if (activeCard === "cardNumber") {
        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(CardElement),
        });

        if (error) {
          setIsProcessing(false);
          toast.error(error.message);
          return;
        }
        paymentMethodId = paymentMethod.id;
      } else {
        paymentMethodId = activeCard;
      }

      const response = await api.post(
        `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/CreatePatientPaymentIntent`,
        {
          items: [
            {
              id: paymentMethodId,
              amount: Number(paymentModel.paidAmount),
            },
          ],
          paymentMethod: activeCard === "cardNumber" ? "Card" : "SavedCard",
          receivedDate: Model.receivedDate,
          copayDOS: Model.copayDOS,
          isCopay: Model.isCopay,
          paymentSource: Model.paymentSource,
          patientId: patientInfo.id || patientDetail.patientId,
          patientName: patientInfo.name || patientDetail.patientName,
          accountNumber: patientInfo.accountNum || patientDetail.accountNum,
          stripeSettingId: stripeSettingId,
          description: Model.notes,
          locationId: Model.locationId,
        }
      );

      if (activeCard === "cardNumber") {
        const { error: confirmError } = await stripe.confirmPayment({
          clientSecret: response.data.dataModel.clientSecret,
          confirmParams: {
            payment_method: paymentMethodId,
            return_url: `${window.location.origin}/completion`,
          },
          redirect: "if_required",
        });

        if (confirmError) {
          toast.error(confirmError.message);
          return;
        }
      }

      toast.success(PAYMENT_SUCCESSFUL);
      onClose(true);
    } catch (error) {
      ErrorHandlingMessage(error)
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
      setIsProcessing(false);
    }
  };

  const handleOnChange = (e) => {
    setActiveCard(e.target.value);
  };
  useEffect(() => {
    (async () => {
      try {
        setState((prev) => ({ ...prev, isLoading: true }));
        const resp = await api.get(
          `${process.env.REACT_APP_TC_PMS
          }/api/StripeConfiguration/FindStripePatientPaymentMethods/${patientInfo?.id || patientDetail?.patientId
          }/${stripeSettingId}`
        );
        setCreditCards(resp.data.dataModel.patientCardInfo);
      } catch (error) {
        ErrorHandlingMessage(error);
      } finally {
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    })();
  }, [patientInfo.id, stripeSettingId]);

  return (
    <>
      {state.isLoading && <FullPageLoader allowFullScreen={true} />}
      <form id="payment-form">
        {/* <PaymentElement /> */}
        {/* <PaymentElement /> */}
        <span className="flex items-center text-sm">
          <span className="mr-1 font-bold text-black/50">Amount: </span>
          <span className="flex items-center text-base font-bold text-black">
            {/* <BiDollar size={17} /> */}
            <img src="/img/patientBalanceBlack.svg" alt="dollar" />
            {NumberConversion(paymentModel.paidAmount).replace("$", "")}
          </span>
        </span>
        <div className="py-4 font-semibold text-md">Saved Cards</div>
        <div className="max-h-[200px] overflow-y-auto">
          {creditCards.map((card, index) => {
            return (
              <div
                key={card.id}
                className="flex items-center justify-between gap-2"
              >
                <div className="flex items-center gap-2">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      name="paymentRadio"
                      onChange={handleOnChange}
                      type="radio"
                      value={card.id}
                      className="hidden"
                    />
                    <div className="relative min-w-[15px] min-h-[15px] border-2 rounded-sm border-secondaryLight/80">
                      <span
                        className={`min-w-[9px] min-h-[9px] absolute top-[1px] left-[1px] bg-primary rounded-sm ${activeCard === card.id || "bg-transparent "
                          }`}
                      ></span>
                    </div>
                  </label>
                  <div
                    className={`flex justify-between py-1 mb-2 border-b last:pb-0 last:border-0 pointer-events-auto opacity-100 
                                    ${activeCard === card.id ||
                      "pointer-events-none opacity-50 "
                      }
                                      `}
                  >
                    <div className="flex items-center gap-2">
                      {cardSVGs[card.cardType] || cardSVGs.unknown}
                      <span className="text-sm font-semibold ">
                        {card.cardNumber} {card.isDefault && `(DEFAULT)`}
                        (Exp. {card.expireDate.replace(/[()]/g, "")})
                      </span>
                      <span className="px-2 py-1 text-xs font-bold uppercase rounded ml-7 text-secondaryLight">
                        {card.holderType}
                      </span>
                    </div>
                  </div>
                </div>
                {/* <button
                  onClick={(e) => openDeletePopup(card)}
                  className="pr-2 text-secondaryLight hover:text-primary"
                >
                  <HiMiniTrash size={14} className="inline-block mr-1" />
                  Delete
                </button> */}
              </div>
            );
          })}
          <div className="py-2 text-sm text-primary">
            Enter card details manually instead
          </div>
          <div className="flex items-center gap-2">
            <div>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  name="paymentRadio"
                  onChange={handleOnChange}
                  type="radio"
                  value="cardNumber"
                  className="hidden"
                />
                <div className="relative min-w-[15px] min-h-[15px] border-2 rounded-sm border-secondaryLight/80">
                  <span
                    className={`min-w-[9px] min-h-[9px] absolute top-[1px] left-[1px] rounded-sm bg-primary
                                    ${activeCard === "cardNumber" ||
                      "bg-transparent"
                      } `}
                  ></span>
                </div>
              </label>
            </div>
            <div className={`w-[95%]`}>
              <CardElement
                options={{
                  classes: {
                    base: "bg-gray-200/50  shadow-sm rounded-md p-2 ",
                  },
                  hidePostalCode: true,
                  disabled: activeCard !== "cardNumber",
                }}
                id="payment-element"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end w-full ">
          <CustomButtonNew
            disabled={isProcessing || !stripe || !elements}
            onClick={handleSubmit}
            variant="outline"
            label={isProcessing ? "Processing ... " : "Pay now"}
          />
        </div>

        {/* Show any error or success messages */}
      </form>
    </>
  );
};

export default CheckoutForm;
